import { z } from 'zod';
export const cihazOlayi = z.object({
    id: z.string(),
    dolapId: z.string().nullable().optional(),
    dolapNumara: z.string().nullable().optional(),
    noktaKod: z.string().nullable().optional(),
    cihazUid: z.string(),
    tip: z.string(),
    data: z.unknown(),
    ctr: z.number().int().nullable().optional(),
    rssi: z.number().int().nullable().optional(),
    snr: z.number().nullable().optional(),
    olusturmaTarihi: z.string().datetime(),
});
export const cihazOlayiSorgusu = z.object({
    sayfa: z.coerce.number().int().min(1).default(1),
    boyut: z.coerce.number().int().min(1).max(1000).default(50),
    noktaId: z.string().optional(),
    dolapId: z.string().optional(),
    cihazUid: z.string().optional(),
    tip: z.string().optional(),
    baslangicTen: z.string().datetime().optional(),
    baslangicAKadar: z.string().datetime().optional(),
});
//# sourceMappingURL=cihaz-olayi.js.map